<template>
  <div>
    <div v-for="(reviewOrder, i) in reviewOrders" :key="i">
      <vs-divider position="center" color="primary" class="f-14 f-bold">
        {{ $tc('review_order', 1) | capitalize }} : {{ reviewOrder.no_order }} |
        {{ $tc('type', 1) | capitalize }}: {{ reviewOrder.invoice_type_name }} |
        {{ $t('approval_date') | capitalize }} :
        {{ formatDate(reviewOrder.approval_date) }}
      </vs-divider>
      <vs-row class="mb-5">
        <vs-col>
          <vs-table :data="reviewOrder.entries.items" noDataText="">
            <template slot="thead">
              <vs-th> {{ $tc('entry', 2) | capitalize }} </vs-th>
              <vs-th> {{ $t('client') | capitalize }} </vs-th>
              <vs-th> {{ $tc('po_number', 1) | capitalize }} </vs-th>
              <vs-th> {{ $t('containers') | capitalize }} </vs-th>
              <vs-th> {{ $t('weight') | capitalize }} </vs-th>
              <vs-th> {{ $t('comments') | capitalize }} </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(entry, i) in data">
                <vs-td :data="entry.entry_id">
                  {{ entry.entry_id }}
                </vs-td>
                <vs-td :data="entry.client_name">
                  {{ entry.client_name }}
                </vs-td>
                <vs-td :data="entry.PO_number">
                  {{ entry.PO_number }}
                </vs-td>
                <vs-td :data="entry.container_string">
                  {{ entry.container_string }}
                </vs-td>
                <vs-td :data="entry.weight">
                  {{ entry.weight }}
                </vs-td>
                <vs-td :data="entry.comments">
                  {{ entry.comments }}
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-bold">
                  {{ $t('total') | capitalize }} {{ $t('weight') | capitalize }}
                </vs-td>
                <vs-td colspan="2">
                  {{ reviewOrder.entries.totals.weight }}
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-bold">
                  {{ $t('total') | capitalize }}
                  {{ $tc('container', 2) | capitalize }}
                </vs-td>
                <vs-td colspan="2">
                  {{ reviewOrder.entries.totals.packs }}
                </vs-td>
              </vs-tr>
              <vs-tr>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td></vs-td>
                <vs-td class="text-bold">
                  {{ $t('total') | capitalize }}
                  {{ $tc('entry', 2) | capitalize }}
                </vs-td>
                <vs-td colspan="2">
                  {{ reviewOrder.entries.items.length }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-col>
      </vs-row>
      <vs-row class="mt-2">
        <vs-col>
          <vs-table :data="reviewOrder.invoices.items" noDataText="">
            <template slot="thead">
              <vs-th>{{ $t('folio') | capitalize }}</vs-th>
              <vs-th
                >{{ $t('bulk') | capitalize }}({{
                  $t('bundle') | capitalize
                }})</vs-th
              >
              <vs-th>{{ $t('requirement_key') | capitalize }}</vs-th>
              <vs-th>{{ $t('no_part') | capitalize }}</vs-th>
              <vs-th>{{ $t('description') | capitalize }}</vs-th>
              <vs-th>{{ $t('english_description') | capitalize }}</vs-th>
              <vs-th>{{ $t('quantity') | capitalize }}</vs-th>
              <vs-th>{{ $t('Unidad medida comercial') | capitalize }}</vs-th>
              <vs-th>{{ $t('Unidad medida tarifa') | capitalize }}</vs-th>
              <vs-th>{{ $t('Factor de conversion') | capitalize }}</vs-th>
              <vs-th>{{ $t('warehouse') | capitalize }}</vs-th>
              <vs-th>{{ $t('Pais de origen') | capitalize }}</vs-th>
              <vs-th>{{ $t('weight') | capitalize }} KG</vs-th>
              <vs-th>{{ $t('weight') | capitalize }} LB</vs-th>
              <vs-th>{{ $t('V. Unit. Compra') | capitalize }}</vs-th>
              <vs-th>{{ $t('V. Unit. Comercial') | capitalize }}</vs-th>
              <vs-th>{{ $t('Valor Total USD') | capitalize }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(invoice, i) in data">
                <vs-td>{{ invoice.fields['Folio Factura'] }}</vs-td>
                <vs-td>{{ invoice.fields['Bultos (Bundles)'] }}</vs-td>
                <vs-td>{{ invoice.fields['Clave de pedimento'] }}</vs-td>
                <vs-td>{{ invoice.fields['No. parte'] }}</vs-td>
                <vs-td>{{ invoice.fields['Descripcion'] }}</vs-td>
                <vs-td>{{ invoice.fields['Descripcion en ingles'] }}</vs-td>
                <vs-td>{{ invoice.fields['Cantidad'] }}</vs-td>
                <vs-td>{{ invoice.fields['Unidad medida comercial'] }}</vs-td>
                <vs-td>{{ invoice.fields['Unidad medida tarifa'] }}</vs-td>
                <vs-td>{{ invoice.fields['Factor de conversion'] }}</vs-td>
                <vs-td>{{ invoice.fields['WareHouse'] }}</vs-td>
                <vs-td>{{ invoice.fields['Pais de origen'] }}</vs-td>
                <vs-td>{{ invoice.fields['Peso KG'] }}</vs-td>
                <vs-td>{{ invoice.fields['Peso LB'] }}</vs-td>
                <vs-td>{{ invoice.fields['V. Unit. Compra'] }}</vs-td>
                <vs-td>{{ invoice.fields['V. Unit. Comercial'] }}</vs-td>
                <vs-td>{{ invoice.fields['Valor Total USD'] }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import mixins from '@/mixins'
export default {
  mixins: [mixins],
  props: {
    reviewOrders: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>
.text-bold {
  font-weight: bold;
}
</style>